// src/vue-inertia-helpers.js
import { router } from '@inertiajs/vue3';

/**
 * Simple wrapper around Inertia router for use in Pinia store
 * Since your app structure might differ, adapt this as needed
 */
export const useRouter = () => {
  return {
    get(url, data = {}, options = {}) {
      return router.get(url, data, options);
    },
    post(url, data = {}, options = {}) {
      return router.post(url, data, options);
    },
    put(url, data = {}, options = {}) {
      return router.put(url, data, options);
    },
    delete(url, options = {}) {
      return router.delete(url, options);
    },
    visit(url, options = {}) {
      return router.visit(url, options);
    }
  };
};